import { useOkapiKy } from '@folio/stripes/core';
import { useMutation } from 'react-query';
import { prepareDataForRequest } from './helpers';
export var useCreateList = function (config) {
    var listObject = config.listObject, onSuccess = config.onSuccess, onError = config.onError;
    var preparedObject = prepareDataForRequest(listObject);
    var ky = useOkapiKy();
    var _a = useMutation(['createList', preparedObject.name], function () { return ky.post('lists', { json: preparedObject }).json(); }, {
        onSuccess: onSuccess,
        onError: onError
    }), saveList = _a.mutate, savingList = _a.isLoading, data = _a.data;
    return ({
        saveList: saveList,
        data: data,
        isLoading: savingList
    });
};
